import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button } from '@material-ui/core';

import { openModal } from 'features/utilsSlice';
import EyeIcon from 'public/icons/eye.svg';
import SimpleDialog from 'components/SimpleDialog';
import EditProfile from 'components/EditProfile';
import ShareProfile from './ShareProfile';
import styles from 'styles/components/profile/Profile.module.scss';

const InfluencerActionsSimplified = ({ profile }) => {
  const dispatch = useDispatch();

  const completed = profile?.completed && profile?.photos?.length > 0;

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div className={styles.edit}>
        <Button
          onClick={() => dispatch(openModal({ name: 'Profile Preview' }))}
          variant="outlined"
          color="secondary"
          endIcon={<EyeIcon />}
          fullWidth
        >
          Preview
        </Button>

        <ShareProfile username={profile?.username} label="Share Rate Card" />
      </div>

      {!completed && (
        <SimpleDialog
          modalName="Simple Dialog"
          description="You need to complete your profile first, and post some pictures before opening this page."
          onClick={() => dispatch(openModal({ name: 'Edit Profile', data: { profile } }))}
          buttonText="Got it"
        />
      )}

      <EditProfile />
    </div>
  );
};

InfluencerActionsSimplified.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default InfluencerActionsSimplified;
